import "./PhysicianDetailsComponent.scss";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent from "../details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../services";
import commonService from "../../services/common.service";

interface PhysicianDetailsViewComponentProps {
    physician?: any;
}

const PhysicianDetailsComponent = (props: PhysicianDetailsViewComponentProps) => {
    const {physician} = props;
    return (
        <div className='physician-details-view'>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"NPI Number"}> {physician?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Prefix"}> {physician?.prefix || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"First Name"}> {physician?.firstName ? CommonService.capitalizeFirstLetterOfEachWord(physician?.firstName) : 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Last Name"}> {physician?.lastName ? CommonService.capitalizeFirstLetterOfEachWord(physician?.lastName) : 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Medicare PTAN Number"}> {physician?.ptanNumber || 'N/A'} </DetailsDataKeyValueComponent>

                </Grid>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Credential"}> {physician?.designation || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Suffix"}> {physician?.suffix || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Middle Name"}> {physician?.middleName ? CommonService.capitalizeFirstLetterOfEachWord(physician?.middleName) : 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Gender"}> {physician?.gender || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Medicaid TIN Number"}> {physician?.tinNumber || 'N/A'} </DetailsDataKeyValueComponent>

                </Grid>
            </Grid>
            <div className={'horizontal-line'}></div>
            <div className="form-sub-title">
                Taxonomy Details
            </div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Primary Taxonomy"}> {physician?.taxonomyDetails?.primary ? "True" : "False" || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Descending Sequence"}> {physician?.taxonomyDetails?.desc || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"License Number"}> {physician?.taxonomyDetails?.license || 'N/A'} </DetailsDataKeyValueComponent>
                </Grid>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Taxonomy Code"}> {physician?.taxonomyDetails?.code || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"State"}> {physician?.taxonomyDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Taxonomy Group"}> {physician?.taxonomyDetails?.group || 'N/A'} </DetailsDataKeyValueComponent>

                </Grid>
            </Grid>

            <div className={'horizontal-line'}></div>
            <div className="form-sub-title">
                Contact Details
            </div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(physician?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"Email Id"}> {physician?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                </Grid>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Fax Number"}> {commonService.getMaskedMobileNumber(physician?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>

                </Grid>
            </Grid>
            <div className={'horizontal-line'}></div>
            <div className="form-sub-title">
                Address Details
            </div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Address Line 1"}> {physician?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"ZIP Code"}> {physician?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"City"}> {physician?.city || 'N/A'} </DetailsDataKeyValueComponent>

                </Grid>
                <Grid item xs={12} sm={12} md={6}
                      xl={6}>
                    <DetailsDataKeyValueComponent
                        title={"Address Line 2"}> {physician?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                    <DetailsDataKeyValueComponent
                        title={"State"}> {physician?.state || 'N/A'} </DetailsDataKeyValueComponent>
                </Grid>
            </Grid>
        </div>
    );

};

export default PhysicianDetailsComponent;
